/**
 * This function is a thin wrapper around `navigator.onLine` which adds support
 * for mocking the return value in tests (`navigator.onLine` cannot be overridden
 * like some globals can). To mock the return, set `globalThis.fakeOnLine`.
 */
export function navigatorIsOnline(): boolean {
  return (globalThis as any).fakeOnLine ?? navigator.onLine;
}
